/* Tojtryk prisberegner – deler logik med forside, beregner-side, produktside og pakker */
(function () {
  const fmt = (n) => Math.round(n).toLocaleString('da-DK') + ' kr.';
  const fmt0 = fmt;

  function readPricing() {
    const el = document.getElementById('tt-pricing');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function tierIndex(pricing, qty) {
    let idx = 0;
    pricing.tiers.forEach((t, i) => { if (qty >= t) idx = i; });
    return idx;
  }

  function logoUnit(pricing, size, colors, qty, heat) {
    const rows = pricing.sizes[size].rows;
    const transfer = rows[tierIndex(pricing, qty)][Math.min(Math.max(colors, 1), 5) - 1];
    const heatPrice = pricing.heat[String(heat)] || pricing.heat['1'];
    return Math.ceil(transfer * pricing.factor + heatPrice * (pricing.heatFactor || 1));
  }

  // Næste antal-trin hvor logoet bliver billigere pr. stk (til "bestil X og spar Y"-tip)
  function nextTier(pricing, qty) {
    return pricing.tiers.find((t) => t > qty) || null;
  }

  function calc(pricing, state) {
    const qty = Math.max(state.qty || 0, pricing.minQty);
    const logos = state.logos.filter((l) => l && l.enabled);
    const logoUnits = logos.map((l) => logoUnit(pricing, l.size, l.colors, qty, state.heat || 1));
    const logoSum = logoUnits.reduce((a, b) => a + b, 0);
    const garment = Math.round(state.price || 0);
    const unit = garment + logoSum;
    // Opstart pr. logo (film): samme logo i samme størrelse to steder = én opstart
    let setupCount = logos.length;
    if (logos.length === 2 && state.logo2Same && logos[0].size === logos[1].size) setupCount = 1;
    const setup = pricing.setup * setupCount;
    const shipping = pricing.shipping;
    const vector = state.vector ? pricing.vectorFee : 0;
    const smallFee = pricing.smallFee && qty < pricing.smallQty ? pricing.smallFee : 0;
    const total = unit * qty + setup + shipping + vector + smallFee;
    let tip = null;
    const nt = nextTier(pricing, qty);
    if (nt && logos.length && nt <= qty * 2.5) {
      const nextUnit = garment + logos.map((l) => logoUnit(pricing, l.size, l.colors, nt, state.heat || 1)).reduce((a, b) => a + b, 0);
      const save = unit - nextUnit;
      // Vis kun tippet når det er et lille spring (fx 40 → 50) eller besparelsen er mærkbar
      if (save > 0 && (nt <= qty * 1.6 || save >= 5)) tip = { qty: nt, unit: nextUnit, save };
    }
    return { qty, garment, logoUnits, logoSum, unit, setup, setupCount, shipping, vector, smallFee, total, totalVat: total * 1.25, tip };
  }

  class TtCalculator extends HTMLElement {
    connectedCallback() {
      this.pricing = readPricing();
      if (!this.pricing) return;
      const pj = this.querySelector('script[data-products]');
      this.products = pj ? JSON.parse(pj.textContent) : [];
      this.state = {
        product: null, price: 0, heat: 1, qty: parseInt(this.dataset.qty || '50', 10), vector: false, logoMode: 'later', logo2Same: true, vat: (localStorage.getItem('ttVat') === '1'), logoLink: '', logoUpload: '',
        logos: [
          { enabled: true, size: this.dataset.size1 || '10', colors: parseInt(this.dataset.colors1 || '1', 10) },
          { enabled: this.dataset.logo2 === 'true', size: this.dataset.size2 || '30', colors: parseInt(this.dataset.colors2 || '1', 10) },
        ],
      };
      if (this.dataset.urlparams === 'true') {
        const q = new URLSearchParams(location.search);
        if (q.get('produkt')) this.dataset.product = q.get('produkt');
        if (q.get('antal')) this.state.qty = parseInt(q.get('antal'), 10) || this.state.qty;
        if (q.get('logo')) this.state.logos[0].size = q.get('logo');
        if (q.get('farver')) this.state.logos[0].colors = parseInt(q.get('farver'), 10) || 1;
        if (q.get('logo2')) { this.state.logos[1].enabled = true; this.state.logos[1].size = q.get('logo2'); this.state.logos[1].colors = parseInt(q.get('farver2') || '1', 10) || 1; }
        this.syncInputsFromState();
      }
      if (this.dataset.product) {
        const p = this.products.find((x) => x.handle === this.dataset.product) || this.products[0];
        if (p) this.selectProduct(p, false);
      } else if (this.products.length && this.dataset.autoselect !== 'false') {
        const def = this.querySelector('[data-cat-panel]:not([hidden]) [data-cat-default]');
        const p = def && this.products.find((x) => x.handle === def.dataset.productTile);
        this.selectProduct(p || this.products[0], false);
      }
      const lm = this.querySelector('[data-logo-mode] input:checked');
      if (lm) this.state.logoMode = lm.value;
      this.bind();
      this.render();
    }

    syncInputsFromState() {
      const qty = this.querySelector('[data-qty]'); if (qty) qty.value = this.state.qty;
      const range = this.querySelector('[data-qty-range]'); if (range) range.value = Math.min(this.state.qty, parseInt(range.max, 10));
      [0, 1].forEach((i) => {
        const l = this.state.logos[i];
        const s = this.querySelector(`[data-logo="${i}"][data-size][value="${l.size}"]`); if (s) s.checked = true;
        const c = this.querySelector(`[data-logo="${i}"][data-colors][value="${l.colors}"]`); if (c) c.checked = true;
      });
      const t = this.querySelector('[data-logo2-toggle]'); if (t) { t.checked = this.state.logos[1].enabled; const p = this.querySelector('[data-logo2-panel]'); if (p) p.hidden = !t.checked; }
    }

    showCat(id) {
      this.querySelectorAll('[data-cat]').forEach((c) => { const on = c.dataset.cat === id; c.classList.toggle('is-active', on); c.setAttribute('aria-selected', on ? 'true' : 'false'); });
      this.querySelectorAll('[data-cat-panel]').forEach((p) => { p.hidden = p.dataset.catPanel !== id; if (!p.hidden) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); } });
      const chip = this.querySelector(`[data-cat="${id}"]`); const n = this.querySelector('[data-cat-name]'); if (chip && n) n.textContent = chip.textContent.trim();
    }

    buildSizeGrid(p) {
      const DEFAULT = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
      let list = p && p.sizes ? String(p.sizes).split('|').map((s) => s.trim()).filter(Boolean) : [];
      if (list.length < 2 || list.length > 16) list = DEFAULT;
      this.querySelectorAll('[data-sizes] .tt-sizes__grid').forEach((grid) => {
        const keep = {}; grid.querySelectorAll('[data-size-qty]').forEach((i) => { if (i.value) keep[i.dataset.sizeQty] = i.value; });
        grid.innerHTML = '';
        list.forEach((z) => { const l = document.createElement('label'); l.className = 'tt-sizes__cell'; l.innerHTML = '<span></span><input type="number" min="0" step="1" inputmode="numeric" placeholder="0">'; l.querySelector('span').textContent = z; const inp = l.querySelector('input'); inp.dataset.sizeQty = z; inp.setAttribute('aria-label', 'Antal ' + z); if (keep[z]) inp.value = keep[z]; grid.appendChild(l); });
      });
      if (this.applySizes) this.applySizes();
    }

    selectProduct(p, rerender = true) {
      this.state.product = p;
      this.buildSizeGrid(p);
      this.state.price = p.price;
      this.state.heat = p.heat || 1;
      this.querySelectorAll('[data-product-tile]').forEach((t) => { const on = t.dataset.productTile === p.handle; t.classList.toggle('is-selected', on); if (t.hasAttribute('aria-pressed')) t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      const tile = this.querySelector(`[data-product-tile="${p.handle}"]`);
      const panel = tile && tile.closest('[data-cat-panel]');
      if (panel && panel.hidden) this.showCat(panel.dataset.catPanel);
      const sel = this.querySelector('[data-product-select]');
      if (sel && sel.value !== p.handle) sel.value = p.handle;
      // Lille produktkort under dropdown'en
      const card = this.querySelector('[data-selected-product]');
      if (card) {
        const img = card.querySelector('[data-sel-img]');
        if (img) { if (p.img) { img.src = p.img; img.alt = p.title; img.hidden = false; } else { img.hidden = true; } }
        const t = card.querySelector('[data-sel-title]'); if (t) t.textContent = p.title.split('|')[0].replace('®', '').trim();
        const nColors = p.colors ? p.colors.split('|').filter(Boolean).length : 0;
        const nSizes = p.sizes ? p.sizes.split('|').filter(Boolean).length : 0;
        const meta = [p.vendor, fmt(p.price) + '/stk. ekskl. moms', nColors ? nColors + ' farver' : '', nSizes ? nSizes + ' størrelser' : ''].filter(Boolean).join(' · ');
        const m = card.querySelector('[data-sel-meta]'); if (m) m.textContent = meta;
        const d = card.querySelector('[data-sel-desc]'); if (d) d.textContent = p.desc || '';
        const cw = card.querySelector('[data-sel-colors]');
        if (cw) {
          cw.innerHTML = ''; this.state.color = '';
          const cols = p.colors ? p.colors.split('|').filter(Boolean) : [];
          if (cols.length) {
            const lab = document.createElement('span'); lab.className = 'tt-colors__label'; lab.textContent = 'Farver – klik og se:'; cw.appendChild(lab);
            cols.forEach((cName) => {
              const b = document.createElement('button'); b.type = 'button'; b.className = 'tt-colors__chip'; b.textContent = cName;
              const src = p.cimg && p.cimg[cName];
              b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); cw.querySelectorAll('.tt-colors__chip').forEach((x) => x.classList.toggle('is-active', x === b)); this.state.color = cName; if (img && src) { img.src = src; } this.fillSummary(); });
              cw.appendChild(b);
            });
            cw.hidden = false;
            // Forvalg: den farve, hovedbilledet viser (ellers den første) – så man kan se, at farverne kan klikkes
            const strip = (u) => (u || '').split('?')[0].split('/').pop();
            let def = cols.find((cName) => p.cimg && p.cimg[cName] && strip(p.cimg[cName]) === strip(p.img)) || cols[0];
            const defBtn = [...cw.querySelectorAll('.tt-colors__chip')].find((b) => b.textContent === def);
            if (defBtn) { defBtn.classList.add('is-active'); this.state.color = def; }
          } else cw.hidden = true;
        }
        if (p.url) card.setAttribute('href', p.url);
        card.hidden = false;
      }
      if (rerender) this.render();
    }

    bind() {
      // Kategori-chips (niveau-vælger): vis panel + vælg det anbefalede produkt
      this.querySelectorAll('[data-cat]').forEach((chip) => {
        chip.addEventListener('click', () => {
          this.showCat(chip.dataset.cat);
          const panel = this.querySelector(`[data-cat-panel="${chip.dataset.cat}"]`);
          const def = panel && (panel.querySelector('[data-cat-default]') || panel.querySelector('[data-product-tile]'));
          if (def) { const p = this.products.find((x) => x.handle === def.dataset.productTile); if (p) this.selectProduct(p); }
        });
      });
      this.querySelectorAll('[data-product-tile]').forEach((t) => {
        t.addEventListener('click', () => {
          const p = this.products.find((x) => x.handle === t.dataset.productTile);
          if (p) this.selectProduct(p);
        });
      });
      const sel = this.querySelector('[data-product-select]');
      if (sel) sel.addEventListener('change', () => {
        const p = this.products.find((x) => x.handle === sel.value);
        if (p) this.selectProduct(p);
      });
      const qty = this.querySelector('[data-qty]');
      const range = this.querySelector('[data-qty-range]');
      const syncQty = (v) => {
        v = parseInt(v, 10);
        if (isNaN(v)) v = this.pricing.minQty;
        this.state.qty = v;
        if (qty && qty !== document.activeElement) qty.value = v;
        if (range) range.value = Math.min(v, parseInt(range.max, 10));
        this.querySelectorAll('[data-qty-preset]').forEach((b) => b.classList.toggle('is-active', parseInt(b.dataset.qtyPreset, 10) === v));
        this.render();
      };
      if (qty) qty.addEventListener('input', () => syncQty(qty.value));
      if (qty) qty.addEventListener('blur', () => { if (this.state.qty < this.pricing.minQty) syncQty(this.pricing.minQty); });
      if (range) range.addEventListener('input', () => syncQty(range.value));
      this.querySelectorAll('[data-qty-preset]').forEach((b) => b.addEventListener('click', () => syncQty(b.dataset.qtyPreset)));
      syncQty(this.state.qty);

      [0, 1].forEach((i) => {
        this.querySelectorAll(`[data-logo="${i}"][data-size]`).forEach((r) => r.addEventListener('change', () => { this.state.logos[i].size = r.value; this.render(); }));
        this.querySelectorAll(`[data-logo="${i}"][data-colors]`).forEach((r) => r.addEventListener('change', () => { this.state.logos[i].colors = parseInt(r.value, 10); this.render(); }));
      });
      this.querySelectorAll('[data-vat-toggle]').forEach((b) => b.addEventListener('click', () => { this.state.vat = b.dataset.vatToggle === '1'; try { localStorage.setItem('ttVat', this.state.vat ? '1' : '0'); } catch (e) {} document.querySelectorAll('tt-calculator').forEach((c) => { if (c !== this && c.state) { c.state.vat = this.state.vat; c.render(); } }); this.render(); }));
      const same = this.querySelector('[data-logo2-same]');
      if (same) same.addEventListener('change', () => { this.state.logo2Same = same.checked; this.render(); });
      const l2 = this.querySelector('[data-logo2-toggle]');
      if (l2) l2.addEventListener('change', () => {
        this.state.logos[1].enabled = l2.checked;
        const panel = this.querySelector('[data-logo2-panel]');
        if (panel) panel.hidden = !l2.checked;
        this.render();
      });
      // Størrelsesfordeling (valgfri) – summen styrer antal
      const sizeBoxes = this.querySelectorAll('[data-sizes]');
      if (sizeBoxes.length) {
        const applySizes = () => {
          let sum = 0; const parts = [];
          this.querySelectorAll('[data-size-qty]').forEach((i) => { const v = parseInt(i.value, 10) || 0; if (v > 0) { sum += v; parts.push(i.dataset.sizeQty + '×' + v); } });
          this.state.sizes = parts.join(', ');
          this.querySelectorAll('[data-sizes-sum]').forEach((el) => (el.textContent = sum));
          if (sum > 0) syncQty(sum); else this.fillSummary();
        };
        sizeBoxes.forEach((b) => b.addEventListener('input', (e) => { if (e.target.matches('[data-size-qty]')) applySizes(); }));
        this.applySizes = applySizes;
      }
      // Sticky prisbar (mobil): skjul når selve resultatet er synligt
      const sticky = this.querySelector('.tt-stickyprice');
      const resultBox = this.querySelector('.tt-result');
      if (sticky && resultBox && 'IntersectionObserver' in window) {
        new IntersectionObserver((entries) => entries.forEach((e) => sticky.classList.toggle('is-hidden', e.isIntersecting)), { threshold: 0.15 }).observe(resultBox);
      }
      const vt = this.querySelector('[data-vector-toggle]');
      if (vt) vt.addEventListener('change', () => { this.state.vector = vt.checked; this.render(); });

      // Logo-fil
      this.querySelectorAll('[data-logo-mode] input').forEach((r) => r.addEventListener('change', () => {
        this.state.logoMode = r.value;
        this.querySelectorAll('[data-logo-panel]').forEach((p) => (p.hidden = p.dataset.logoPanel !== r.value));
        this.fillSummary();
      }));
      const initial = this.querySelector('[data-logo-mode] input:checked');
      if (initial) this.querySelectorAll('[data-logo-panel]').forEach((p) => (p.hidden = p.dataset.logoPanel !== initial.value));
      const link = this.querySelector('[data-logo-link]');
      if (link) link.addEventListener('input', () => { this.state.logoLink = link.value; this.fillSummary(); });
      const file = this.querySelector('[data-logo-file]');
      if (file) file.addEventListener('change', () => this.uploadLogo(file));

      const openBtn = this.querySelector('[data-open-form]');
      if (openBtn && this.querySelector('[data-form-flag]')) { const panel = this.querySelector('[data-inline-form]'); const wrap = this.querySelector('[data-open-wrap]'); if (panel) { panel.hidden = false; if (wrap) wrap.hidden = true; setTimeout(() => panel.scrollIntoView({ block: 'center' }), 50); } }
      if (openBtn) openBtn.addEventListener('click', () => {
        const panel = this.querySelector('[data-inline-form]'); const wrap = this.querySelector('[data-open-wrap]');
        if (!panel) return;
        panel.hidden = false; panel.classList.add('is-open'); if (wrap) wrap.hidden = true;
        this.fillSummary();
        const y = panel.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top: y, behavior: 'smooth' });
        const first = panel.querySelector('input[name="contact[Navn]"]');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 450);
      });
      const share = this.querySelector('[data-share]');
      if (share) share.addEventListener('click', async () => {
        const url = location.origin + this.continueUrl();
        const lab = share.querySelector('[data-share-label]');
        try { await navigator.clipboard.writeText(url); lab.textContent = 'Link kopieret – send det til en kollega'; }
        catch (e) { window.prompt('Kopiér linket:', url); }
        share.classList.add('is-done');
        setTimeout(() => { lab.textContent = 'Kopiér link til denne beregning'; share.classList.remove('is-done'); }, 3500);
      });
      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', (e) => {
        if (this.state.logoMode === 'upload' && this.uploading) { e.preventDefault(); this.setStatus('Vent – logoet uploader stadig …'); return; }
        this.fillSummary();
        if (form.checkValidity()) { const b = form.querySelector('[type=submit]'); if (b) { setTimeout(() => { b.disabled = true; b.classList.add('is-sending'); b.textContent = 'Sender …'; }, 0); } }
      });
    }

    setStatus(msg, ok) {
      const s = this.querySelector('[data-upload-status]');
      if (s) { s.textContent = msg; s.classList.toggle('tt-ok', !!ok); }
    }

    async uploadLogo(input) {
      const f = input.files && input.files[0];
      if (!f) return;
      const ok = /\.(pdf|ai|svg|eps)$/i.test(f.name);
      if (!ok) { input.value = ''; this.setStatus('Filen skal være en vektorfil: PDF, AI, SVG eller EPS. Har I kun PNG/JPG, så vælg “Jeg sender det senere” og tilkøb rentegning.'); return; }
      if (f.size > 25 * 1024 * 1024) { input.value = ''; this.setStatus('Filen er for stor (max 25 MB) – send et link i stedet.'); return; }
      const cloud = this.pricing.upload && this.pricing.upload.cloud;
      const preset = this.pricing.upload && this.pricing.upload.preset;
      if (!cloud || !preset) { this.setStatus('Upload er ikke sat op endnu – send et link eller logoet på mail.'); return; }
      this.uploading = true;
      this.setStatus('Uploader ' + f.name + ' …');
      try {
        const fd = new FormData();
        fd.append('file', f);
        fd.append('upload_preset', preset);
        const r = await fetch('https://api.cloudinary.com/v1_1/' + cloud + '/auto/upload', { method: 'POST', body: fd });
        const j = await r.json();
        if (j.secure_url) { this.state.logoUpload = j.secure_url; this.setStatus('✓ ' + f.name + ' er modtaget.', true); }
        else throw new Error(j.error && j.error.message);
      } catch (e) {
        this.setStatus('Upload fejlede – send et link eller logoet på mail i stedet.');
      }
      this.uploading = false;
      this.fillSummary();
    }

    continueUrl() {
      const s = this.state; const u = new URL(this.dataset.continueUrl || '/pages/beregn-pris', location.origin);
      if (s.product) u.searchParams.set('produkt', s.product.handle);
      u.searchParams.set('antal', s.qty);
      u.searchParams.set('logo', s.logos[0].size);
      u.searchParams.set('farver', s.logos[0].colors);
      if (s.logos[1].enabled) { u.searchParams.set('logo2', s.logos[1].size); u.searchParams.set('farver2', s.logos[1].colors); }
      return u.pathname + u.search + '#pris';
    }

    summaryText() {
      const r = this.result; const s = this.state; const P = this.pricing;
      const lines = [];
      lines.push('Produkt: ' + (s.product ? s.product.title + ' (' + s.product.handle + ')' : 'Ikke valgt'));
      lines.push('Antal: ' + r.qty + ' stk.' + (s.sizes ? ' (' + s.sizes + ')' : ''));
      let k = 0;
      s.logos.forEach((l, i) => { if (l.enabled) { lines.push('Logo ' + (i + 1) + ': ' + P.sizes[l.size].label + ', ' + l.colors + ' farve' + (l.colors > 1 ? 'r' : '') + ' – ' + fmt(r.logoUnits[k]) + '/stk.'); k++; } });
      if (s.color) lines.push('Farve (foreløbig): ' + s.color);
      lines.push('Tøj: ' + fmt(r.garment) + '/stk. | Pr. stk. i alt: ' + fmt(r.unit));
      lines.push('Opstart: ' + fmt(r.setup) + ' | Fragt: ' + fmt(r.shipping) + (r.vector ? ' | Rentegning: ' + fmt(r.vector) : '') + (r.smallFee ? ' | Småordre-tillæg: ' + fmt(r.smallFee) : ''));
      lines.push('Vejledende total ekskl. moms: ' + fmt(r.total) + ' (inkl. moms ' + fmt(r.totalVat) + ')');
      lines.push('Logo-fil: ' + (s.logoMode === 'upload' ? (s.logoUpload || 'upload ikke gennemført') : s.logoMode === 'link' ? (s.logoLink || 'link mangler') : 'sendes senere'));
      return lines.join('\n');
    }

    fillSummary() {
      if (!this.result) return;
      const f = this.querySelector('[data-summary-field]');
      if (f) f.value = this.summaryText();
      const lf = this.querySelector('[data-logo-field]');
      if (lf) lf.value = this.state.logoMode === 'upload' ? this.state.logoUpload : this.state.logoMode === 'link' ? this.state.logoLink : 'Sendes senere';
      const subj = this.querySelector('[data-subject-field]');
      if (subj && this.state.product) subj.value = 'Forespørgsel: ' + this.result.qty + ' × ' + this.state.product.title;
      const c = this.querySelector('[data-continue]');
      if (c) c.setAttribute('href', this.continueUrl());
    }

    render() {
      const r = (this.result = calc(this.pricing, this.state));
      const vat = this.state.vat; const M = vat ? 1.25 : 1; const fmt = (v) => fmt0(Math.round(v * M));
      this.querySelectorAll('[data-vat-label]').forEach((el) => (el.textContent = vat ? 'inkl. moms' : 'ekskl. moms'));
      this.querySelectorAll('[data-vat-toggle]').forEach((b) => { const on = b.dataset.vatToggle === (vat ? '1' : '0'); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      const set = (sel, val) => this.querySelectorAll(sel).forEach((el) => {
        if (el.textContent !== val && el.textContent !== '–' && (sel === '[data-out-unit]' || sel === '[data-out-total]')) {
          el.classList.remove('tt-bump'); void el.offsetWidth; el.classList.add('tt-bump');
        }
        el.textContent = val;
      });
      this.querySelectorAll('[data-product-tile]').forEach((t) => { const p = (this.products || []).find((x) => x.handle === t.dataset.productTile); const s = t.querySelector('.tt-tier__price strong'); const l = t.querySelector('.tt-tier__price small'); if (p && s) s.textContent = fmt(p.price); if (l) l.textContent = 'tøjpris ' + (vat ? 'inkl.' : 'ekskl.') + ' moms'; });
      set('[data-out-unit]', fmt(r.unit));
      set('[data-out-garment]', fmt(r.garment));
      set('[data-out-setup]', fmt(r.setup));
      const sl = this.querySelector('[data-out-setup-label]'); if (sl) sl.textContent = r.setupCount > 1 ? '(' + r.setupCount + ' logoer)' : '(pr. logo)';
      set('[data-out-shipping]', fmt(r.shipping));
      set('[data-out-vector]', fmt(r.vector));
      set('[data-out-smallfee]', fmt(r.smallFee));
      const sf = this.querySelector('[data-smallfee-line]');
      if (sf) sf.hidden = !r.smallFee;
      const tipEl = this.querySelector('[data-tip]');
      if (tipEl) {
        tipEl.hidden = !r.tip;
        if (r.tip) {
          tipEl.innerHTML = '';
          const b = document.createElement('button'); b.type = 'button'; b.className = 'tt-tip__btn';
          b.textContent = 'Tip: ved ' + r.tip.qty + ' stk. er prisen ' + fmt(r.tip.unit) + '/stk. – spar ' + fmt(r.tip.save) + ' pr. stk. Vælg ' + r.tip.qty + ' →';
          b.addEventListener('click', () => { const q = this.querySelector('[data-qty]'); if (q) { q.value = r.tip.qty; q.dispatchEvent(new Event('input', { bubbles: true })); } });
          tipEl.appendChild(b);
        }
      }
      set('[data-out-total]', fmt(r.total));
      set('[data-out-total-vat]', vat ? fmt0(Math.round(r.total)) : fmt0(Math.round(r.totalVat)));
      this.querySelectorAll('[data-vat-other-label]').forEach((el) => (el.textContent = vat ? 'Ekskl. moms' : 'Inkl. moms'));
      set('[data-out-qty]', r.qty);
      set('[data-out-product]', this.state.product ? this.state.product.title.split('|')[0].replace('®', '').trim() : 'Tøj');
      const warn = this.querySelector('[data-min-warning]');
      if (warn) warn.hidden = (this.state.qty || 0) >= this.pricing.minQty;
      const vl = this.querySelector('[data-vector-line]');
      if (vl) vl.hidden = !this.state.vector;
      let k = 0;
      this.querySelectorAll('[data-logo-line]').forEach((el, i) => {
        const l = this.state.logos[i];
        const enabled = l && l.enabled;
        el.hidden = !enabled;
        if (enabled) { el.querySelector('[data-logo-line-price]').textContent = fmt(r.logoUnits[k]); k++; }
      });
      this.fillSummary();
    }
  }
  if (!customElements.get('tt-calculator')) customElements.define('tt-calculator', TtCalculator);
})();
